import { apiFetchWithErrorCheck as api} from 'component-library';

/*This function makes a call to the  rest api
props: (object)
	data: (objt) the data to send
 */
export function apiFetch(props) {
	return wp.apiFetch({ 
		path: '/rf/v4/data',
		method: 'POST',
		data: props,	
	});
}

export function apiFetchWithError(props) {
	return apiFetch(props).then( 
		(results) =>  {
			//if there is a problem then show this message
			if (results === null) {
				alert('Error with the REST API. Please contact the website admin and let them know this error.');
			} 	
			return results;
		}
	);
}

export function apiFetchWithErrorCheck (props) {
	return api({path:'/rf/v4/data', data:props});
}